import {createReducer, on} from '@ngrx/store';
import {ParametryBiznesowe} from './parametryBiznesowe';
import {aktualizujParametrBiznesowy} from './parametryBiznesowe.actions';


export const initialParametryBiznesoweState: ParametryBiznesowe<string | number> = {}

export const parametryBiznesoweReducer = createReducer(
  initialParametryBiznesoweState,
  on(aktualizujParametrBiznesowy, (state, action) => {
    return {
      ...state,
      [action.nazwa]: action.wartosc
    }
  }),
);

